<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">Recherche simple</v-list-item-title>
        <v-list-item-subtitle>Vous souhaitez obtenir </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action class="d-print-none">
        <envoi-message
          v-if="envoiEnabled"
          :typeObjet="this.typeObjet"
          :selectedContacts="selectedContact"
          :recherche="[]"
          :nbContacts="selectedContact.length"
        />
      </v-list-item-action>

      <v-list-item-action class="d-print-none">
        <export
          :typeObjet="this.typeObjet"
          typeRecherche="simple"
          :datasourceContact="datasourceContact"
          :datasourcePersonneMorale="datasourcePersonneMorale"
          :datasourceInstance="datasourceInstance"
          :selectedContact="selectedContact"
          :selectedPersonneMorale="selectedPersonneMorale"
          :selectedInstance="selectedInstance"
        />
      </v-list-item-action>

      <v-list-item-action class="ml-0 d-print-none">
        <printButton />
      </v-list-item-action>
    </v-list-item>
    <v-card-text class="pt-0">
      <v-tabs color="primary">
        <v-tab @click="tabPersonnePhysique()">
          {{ this.$t('recherche.rechercheSimple.tabs.contact') }}
        </v-tab>
        <v-tab @click="tabPersonneMorale()">
          {{ this.$t('recherche.rechercheSimple.tabs.personneMorale') }}
        </v-tab>
        <v-tab @click="tabInstance()">
          {{ this.$t('recherche.rechercheSimple.tabs.instance') }}
        </v-tab>
        <!-- recherche contact -->
        <v-tab-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>
                {{
                  this.$t(
                    'recherche.rechercheSimple.personnePhysique.search.title',
                  )
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-row>
            <v-col cols="12" sm="4">
              <search-by
                :datasource="datasourceContact"
                attr="nom"
                @storeSearch="storeSearch('contact', 'nom', $event)"
                i18n="recherche.rechercheSimple.personnePhysique.search.nom"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <search-by
                :datasource="datasourceContact"
                attr="prenom"
                @storeSearch="storeSearch('contact', 'prenoms', $event)"
                i18n="recherche.rechercheSimple.personnePhysique.search.prenoms"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <search-by
                :datasource="datasourceContact"
                attr="raisonSociale"
                @storeSearch="storeSearch('contact', 'raisonSociale', $event)"
                i18n="recherche.rechercheSimple.personnePhysique.search.raisonSociale"
              />
            </v-col>
          </v-row>

          <datasource-table
            :datasource="datasourceContact"
            :callRefresh="callRefresh"
            :ripple="false"
            :tableProps="{ showSelect: true }"
            v-model="selectedContact"
            ref="datasourceTableContact"
          >
            <template #item.raisonSociale="{item}">
              <navigable-link
                :to="$liens().personneMorale(item.idPersonneMorale)"
                >{{ item.raisonSociale }}
              </navigable-link>
            </template>

            <template #item.nom="{item}">
              <navigable-link
                :to="
                  $liens().personnePhysique(item.idPersonnePhysique, item.id)
                "
              >
                {{ item.nom }}
              </navigable-link>
            </template>
            <template #item.prenoms="{item}">
              <navigable-link
                :to="
                  $liens().personnePhysique(item.idPersonnePhysique, item.id)
                "
              >
                {{ item.prenoms }}
              </navigable-link>
            </template>

            <template #item.telephone="{item}">
              <span class="text-no-wrap">{{
                getInternational(item.telephone)
              }}</span>
              <v-tooltip v-if="item.telephoneConfidentiel" bottom>
                <template #activator="{ on }">
                  <v-icon v-on="on">mdi-eye-off</v-icon>
                </template>
                <span>Confidentiel</span>
              </v-tooltip>
            </template>
          </datasource-table>
        </v-tab-item>

        <!-- recherche personne morale -->
        <v-tab-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>
                {{
                  this.$t(
                    'recherche.rechercheSimple.personneMorale.search.title',
                  )
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-row>
            <v-col cols="12" sm="6">
              <search-by
                :datasource="datasourcePersonneMorale"
                attr="raisonSociale"
                @storeSearch="
                  storeSearch('personneMorale', 'raisonSociale', $event)
                "
                i18n="recherche.rechercheSimple.personneMorale.search.raisonSociale"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <search-by
                :datasource="datasourcePersonneMorale"
                attr="departement"
                @storeSearch="
                  storeSearch('personneMorale', 'departement', $event)
                "
                i18n="recherche.rechercheSimple.personneMorale.search.departement"
              />
            </v-col>
          </v-row>

          <datasource-table
            v-model="selectedPersonneMorale"
            :datasource="datasourcePersonneMorale"
            :callRefresh="callRefresh"
            :tableProps="{ showSelect: true }"
            ref="datasourceTablePersonneMorale"
          >
            <template #item.nomUsuel="{item}">
              <navigable-link :to="$liens().personneMorale(item.id)">
                {{ item.nomUsuel }}
              </navigable-link>
            </template>
            <template #item.raisonSociale="{item}">
              <navigable-link :to="$liens().personneMorale(item.id)">
                {{ item.raisonSociale }}
              </navigable-link>
            </template>
            <template #item.telephone="{item}">
              <span class="text-no-wrap">{{
                getInternational(item.telephone)
              }}</span>
            </template>
          </datasource-table>
        </v-tab-item>
        <!-- recherche Instance-->
        <v-tab-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>
                {{ this.$t('recherche.rechercheSimple.instance.search.title') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-row>
            <v-col cols="12" sm="6">
              <search-by
                :datasource="datasourceInstance"
                attr="nom"
                @storeSearch="storeSearch('instance', 'nom', $event)"
                i18n="recherche.rechercheSimple.instance.search.nom"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <search-by
                :datasource="datasourceInstance"
                attr="id"
                typeChamp="number"
                @storeSearch="storeSearch('instance', 'idInstance', $event)"
                i18n="recherche.rechercheSimple.instance.search.id"
              />
            </v-col>
          </v-row>

          <datasource-table
            v-model="selectedInstance"
            :datasource="datasourceInstance"
            :callRefresh="callRefresh"
            :tableProps="{ showSelect: true }"
            ref="datasourceTableInstance"
          >
            <template #item.nom="{item}">
              <navigable-link :to="$liens().instance(item.id)">
                {{ item.nom }}
              </navigable-link>
            </template>
          </datasource-table>
        </v-tab-item>
      </v-tabs>
    </v-card-text>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';
import { getInternational } from '@/components/telephone/telephoneUtil.js';

export default {
  props: {
    fieldName: {
      type: Array,
      default() {
        return ['_select-one'];
      },
    },
    capabilities: {
      type: String,
      default: 'create,search',
    },
    selectAll: {
      type: Boolean,
      default: true,
    },
    callRefresh: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.typeObjet = 'contact';
    this.datasourceContact.refresh();
    this.$store.commit('origine/recherche', {
      recherche: 'recherchesimple',
    });
  },
  data() {
    const datasourceContact = new Datasource('recherche/simple/contact', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['nom'],
      descending: [false],
      selectAll: this.selectAll,
      labelNamespace: 'recherche.rechercheSimple.personnePhysique.list',
      args: {},
      fields: [
        {
          value: 'nom',
          sortable: true,
        },
        {
          value: 'prenoms',
          sortable: true,
        },
        {
          value: 'raisonSociale',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.personneMorale',
          ),
        },

        {
          value: 'fonction',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.fonction',
          ),
        },
        {
          value: 'telephone',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.telephone',
          ),
        },
        {
          value: 'mail',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.mail',
          ),
        },
      ],
    });

    const datasourcePersonneMorale = new Datasource(
      'recherche/simple/personne-morale',
      {
        page: 1,
        rowsPerPage: 20,
        sortBy: ['nomUsuel'],
        descending: [false],
        selectAll: this.selectAll,
        labelNamespace: 'recherche.rechercheSimple.personneMorale.list',
        args: {
          actif: true,
        },
        fields: [
          {
            value: 'nomUsuel',
            sortable: true,
          },
          {
            value: 'raisonSociale',
            sortable: true,
          },
          {
            value: 'departement',
            sortable: false,
          },
          {
            value: 'ville',
            sortable: false,
          },
          {
            value: 'telephone',
            sortable: false,
          },
        ],
      },
    );

    const datasourceInstance = new Datasource('recherche/simple/instance', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['nom'],
      descending: [false],
      selectAll: this.selectAll,
      labelNamespace: 'recherche.rechercheSimple.instance.list',
      args: {
        actif: true,
      },
      fields: [
        {
          value: 'nom',
          sortable: true,
          text: this.$t('recherche.rechercheSimple.instance.list.headers.nom'),
        },
        {
          value: 'referent',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.referent',
          ),
        },
        {
          value: 'nomsGestionnaires',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.personnePhysique',
          ),
        },
        {
          value: 'size',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.numberOfUser',
          ),
        },
      ],
    });

    const initialSearch = this.$store.state.search.oldSearchField;
    datasourceContact.page = initialSearch.contact.page;
    Object.entries(initialSearch.contact.args).forEach(element => {
      datasourceContact.args[element[0]] = element[1];
    });

    datasourceInstance.page = initialSearch.instance.page;
    Object.entries(initialSearch.instance.args).forEach(element => {
      datasourceInstance.args[element[0]] = element[1];
    });

    datasourcePersonneMorale.page = initialSearch.personneMorale.page;
    Object.entries(initialSearch.personneMorale.args).forEach(element => {
      datasourcePersonneMorale.args[element[0]] = element[1];
    });

    return {
      datasourceContact,
      datasourcePersonneMorale,
      datasourceInstance,

      // Les v-model des 3 DatasourceTable
      selectedContact: [],
      selectedPersonneMorale: [],
      selectedInstance: [],

      // L'onglet sélectionné
      typeObjet: 'contact',

      form: {},
      column: null,
      row: null,
      active: 1,
    };
  },
  computed: {
    envoiEnabled() {
      return this.typeObjet === 'contact' && this.$auth.hasRole('PRIV_ENVOI');
    },
  },
  methods: {
    getInternational,
    storeSearch(entity, fieldName, value) {
      this.$store.commit('search/updateSearchField', {
        entity: entity,
        field: fieldName,
        value: value,
      });
    },

    changeCallRefreshValue(val) {
      if (this.$refs.datasourceTableContact) {
        this.$refs.datasourceTableContact.changeCallRefreshValue(val);
        this.$refs.datasourceTableContact.datasourceRefresh();
      }
      if (this.$refs.datasourceTablePersonneMorale) {
        this.$refs.datasourceTablePersonneMorale.changeCallRefreshValue(val);
        this.$refs.datasourceTablePersonneMorale.datasourceRefresh();
      }
      if (this.$refs.datasourceTableInstance) {
        this.$refs.datasourceTableInstance.changeCallRefreshValue(val);
        this.$refs.datasourceTableInstance.datasourceRefresh();
      }
    },
    tabPersonnePhysique() {
      this.datasourceContact.refresh();
      this.typeObjet = 'contact';
    },
    tabPersonneMorale() {
      this.datasourcePersonneMorale.refresh();
      this.typeObjet = 'personneMorale';
    },
    tabInstance() {
      this.datasourceInstance.refresh();
      this.typeObjet = 'instance';
    },
  },
};
</script>
